import React, { useState, useEffect } from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
import Section from 'components/section';
import Dial from '../dial';
const cx = cls(styles);

const planMap = [
	{
		icon: 'https://web-data.zmlearn.com/image/pguXt3aqUXRkD8RQMA97cx/plan_icon_1%402x.png',
		title: 'Diagnosis first',
		index: 1,
	},
	{
		icon: 'https://web-data.zmlearn.com/image/fpsKCj1hJZk1WxgrDEBBwv/plan_icon_2%402x.png',
		title: 'Scheme planning',
		index: 2,
	},
	{
		icon: 'https://web-data.zmlearn.com/image/g5ms9owQvgMSRTKK2e7hcD/plan_icon_3%402x.png',
		title: 'Effect guarantee',
		index: 3,
	},
	{
		icon: 'https://web-data.zmlearn.com/image/4JHh94vdbhxRsRe9szzACW/plan_icon_4%402x.png',
		title: 'Reports analysis',
		index: 4,
	},
];
/**
 * 学习规划模块
 * @returns
 */
export default function PlanBox() {
	const [show, setShow] = useState<boolean>(false);
	const [step, setStep] = useState<number>(1);
	useEffect(() => {
		// 滚动
		const formEle = document.querySelector('#plan-block') as HTMLDivElement;

		const options = {
			threshold: [0, 0.25, 0.5, 0.75],
		};

		const observer = new IntersectionObserver((entries) => {
			const show = entries[0].intersectionRatio <= 0;
			if (show) {
				setShow(true);
				observer.disconnect();
			}
		}, options);
		observer.observe(formEle);
		return () => {
			observer.disconnect();
		};
	}, []);
	const onHoverHandle = (step: number) => {
		setStep(step);
	};
	return (
		<div className={cx('plan-block')} id="plan-block">
			<Section>
				<h3 className={cx('plan-title block-title')}>Unique tailored learning plans for each student</h3>
				<div className={cx('plan-list')}>
					{planMap.map((item, i) => {
						return (
							<div
								key={item.index}
								className={cx('plan-item')}
								onMouseEnter={() => onHoverHandle(i + 1)}
								onClick={() => onHoverHandle(i + 1)}
								onTouchStart={() => onHoverHandle(i + 1)}>
								<span className={step === i + 1 ? cx('active') : ''}>{item.index}</span>
								<div>
									<img loading="lazy" src={item.icon} alt="" />
									{item.title}
								</div>
							</div>
						);
					})}
					<Dial step={show ? step : 0} />
				</div>
			</Section>
		</div>
	);
}
